import * as React from "react"

import LinkIconBlock from "./LinkIconBlock"
import SkuLabel from "./SkuLabel"


export default function SkuLinkLabel({ url, skuName, ellipsis, maxWidth }) {
	return <LinkIconBlock url={url} variant="body2" sx={{ display: "inline-block" }} linkProps={{ sx: { display: 'flex' } }}>
		<SkuLabel label={skuName} ellipsis={ellipsis} maxWidth={maxWidth} />
	</LinkIconBlock>
}